import script from "./DeshboardSideMenu.vue?vue&type=script&setup=true&lang=js"
export * from "./DeshboardSideMenu.vue?vue&type=script&setup=true&lang=js"

import "./DeshboardSideMenu.vue?vue&type=style&index=0&id=c5c8c6c4&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c5c8c6c4"]])

export default __exports__